import gql from 'graphql-tag';
import { Fragments } from '@shared/api';
import {
  AuditCheckboxComponent,
  AuditTagComponent,
  AuditTextComponent,
  StaticTextComponent,
} from '../fragments/component';

export const getWorkflowTemplate = gql`
  query GetWorkflowTemplateQuery($id: UUID!) {
    getWorkflowTemplate(id: $id) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const listWorkflowTemplates = gql`
  query ListWorkflowTemplatesQuery($input: ListWorkflowTemplates!) {
    listWorkflowTemplates(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const listWorkflowTemplatesV2 = gql`
  query ListWorkflowTemplatesV2Query($input: ListWorkflowTemplates!) {
    listWorkflowTemplatesV2(input: $input) {
      hasMore
      workflowTemplates {
        ...WorkflowTemplate
      }
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const listWorkflowEntities = gql`
  query ListWorkflowEntitiesQuery($input: ListWorkflowEntities!) {
    list: listWorkflowEntities(input: $input) {
      hasMore
      totalResults
      cursor
      inverseRelatedCardCounts {
        cardId
        count
      }
      entities {
        ...WorkflowEntity
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.workflow.WorkflowEntity}
  ${Fragments.entity.EntityRefs}
`;

export const countWorkflowEntities = gql`
  query CountWorkflowEntitiesQuery($input: CountWorkflowEntities!) {
    countWorkflowEntities(input: $input) {
      totalResults
    }
  }
`;

export const getWorkflowEntity = gql`
  query GetWorkflowEntityQuery($input: GetWorkflowEntity!) {
    workflowEntity: getWorkflowEntity(input: $input) {
      entity {
        ...WorkflowEntity
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.workflow.WorkflowEntity}
  ${Fragments.entity.EntityRefs}
`;

export const getWorkflowEntities = gql`
  query GetWorkflowEntitiesQuery($input: GetWorkflowEntities!) {
    workflowEntities: getWorkflowEntities(input: $input) {
      entities {
        ...WorkflowEntity
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.workflow.WorkflowEntity}
  ${Fragments.entity.EntityRefs}
`;

export const getSubformComponents = gql`
  query GetSubformComponentsQuery($input: GetSubformComponents!) {
    getSubformComponents(input: $input) {
      subformComponents {
        auditCheckboxComponent {
          ...AuditCheckboxComponent
        }
        auditTagComponent {
          ...AuditTagComponent
        }
        auditTextComponent {
          ...AuditTextComponent
        }
        staticTextComponent {
          ...StaticTextComponent
        }
      }
      errorMessage
    }
  }

  ${AuditCheckboxComponent}
  ${AuditTagComponent}
  ${AuditTextComponent}
  ${StaticTextComponent}
`;
